
<!--
 * @Author: your name
 * @Date: 2021-06-22 13:59:06
 * @LastEditTime: 2024-07-31 16:10:19
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\AttrList\AttrTimewait.vue
-->
<!--正计时-->

<template>
  <div class="attr-timewait">
    <div class="timewait-item flex-b-c">
      <span class="timewait-attr">{{$t('PE.Name')}}</span>
      <span>{{$t('PE.Timing')}}</span>
    </div>
    <div class="timewait-item flex-b-c">
      <span class="timewait-attr">{{$t('PE.Title')}}</span>
      <el-input v-model="media.ext_val_text" :placeholder="$t('basics.PleaseInput')" size="mini" style="width:130px;"></el-input>
    </div>
    <div class="timewait-item flex-b-c">
      <span class="timewait-attr">{{$t('PE.TimerMode')}}</span>
      <el-select v-model="media.ext_val_isRelativeTime" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="(item, index) in methods" :key="index" :label="$t(item.label)" :value="item.value"></el-option>
      </el-select>
    </div>
    <!-- 相对时间 -->
    <div class="timewait-item flex-b-c" v-if="media.ext_val_isRelativeTime">
      <span class="timewait-attr">{{$t('PE.RelativeTime')}}</span>
      <div class="timewait-attr-child">
        <el-input-number
          v-model="relativeTime"
          @change="relativeTimeChange"
          controls-position="right"
          :min="0"
          size="mini"
        ></el-input-number>
        <el-select v-model="timeunitType" :placeholder="$t('basics.PleaseSelect')" size="mini">
          <el-option v-for="item in timeunits" :key="item.value" :label="$t(item.label)" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <!-- 绝对时间 -->
    <div class="timewait-item flex-b-c" v-else>
      <span class="timewait-attr">{{$t('PE.AbsoluteTime')}}</span>
      <el-date-picker
        v-model="media.ext_val_absoluteTime"
        type="datetime"
        :placeholder="$t('cswcaat1')"
        :picker-options="pickerOptions"
        :clearable="false"
        size="mini"
        style="width:130px;"
      ></el-date-picker>
    </div>
    <div class="timewait-item flex-b-c">
      <span class="timewait-attr">{{$t('PE.DisplayMode')}}</span>
      <div style="width: 130px;">
        <el-checkbox v-model="media.ext_val_showDay" :label="$t('PE.Day')"></el-checkbox>
        <el-checkbox v-model="media.ext_val_showHour" :label="$t('PE.Hour')"></el-checkbox>
        <el-checkbox v-model="media.ext_val_showMinute" :label="$t('PE.Minutes')"></el-checkbox>
        <el-checkbox v-model="media.ext_val_showSecond" :label="$t('PE.Second')"></el-checkbox>
      </div>
    </div>
    <div class="timewait-item flex-b-c">
      <span class="timewait-attr">{{$t('PE.EditStyle')}}</span>
      <el-select v-model="media.ext_val_style" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in timestyles" :key="item.value" :label="$t(item.label)" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="timewait-item flex-b-c">
      <span class="timewait-attr">{{$t('PE.DisplayUsage')}}</span>
      <div style="width: 130px;" class="flex-b-c">
        <el-radio v-model="media.ext_val_singleLine" :label="true" style="margin-right: 26px;">{{$t('PE.ARow')}}</el-radio>
        <el-radio v-model="media.ext_val_singleLine" :label="false" style="margin-right: 26px;">{{$t('PE.MultiRow')}}</el-radio>
      </div>
    </div>
    <div class="timewait-item flex-b-c">
      <span class="timewait-attr">{{$t('PE.FontFamily')}}</span>
      <div class="timewait-attr-child" style="height: 96px;">
        <el-select v-model="media.ext_val_family" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in familys" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div style="width:130px;">
          <set-font-size @setFontSize="setFontSize" :defaultSize="media.ext_val_textSize"></set-font-size>
        </div>
        <!-- <el-select v-model="media.ext_val_textSize" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in fontSize" :key="item" :label="item+'px'" :value="item"></el-option>
        </el-select>-->
        <div class="flex-a-c">
          <el-color-picker
            class="font-color-picker"
            v-model="media.ext_val_backgroundColor"
            size="mini"
            :title="$t('PE.BackgroundColor')"
            :show-alpha="true"
            :predefine="predefineColors"
          ></el-color-picker>
          <el-color-picker
            class="font-color-picker"
            v-model="media.ext_val_textColor"
            size="mini"
            :title="$t('PE.FontColor')"
            :show-alpha="true"
            :predefine="predefineColors"
          ></el-color-picker>
        </div>
      </div>
    </div>
    <div class="timewait-item flex-b-c">
      <span class="timewait-attr">{{$t('PE.EnterTheAnimation')}}</span>
      <el-select v-model="media.ext_val_anim" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in animations" :key="item.id" :label="$t(item.i18n)" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="timewait-item flex-b-c">
      <span class="timewait-attr">{{$t('PE.TheEntryTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_enterTime" :min="1" size="mini"></el-input-number>
    </div>
    <div class="timewait-item flex-b-c">
      <span class="timewait-attr">{{$t('PE.PlayTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')" size="mini"></el-input-number>
    </div>
  </div>
</template>

<script>
import familys from '@static/data/familys.js';
// import fontSize from '@static/data/fontSize.js';
import SetFontSize from './children/SetFontSize';
import animations from '../../scripts/animations';
import predefineColors from '@static/data/predefineColors.js';
// 计时方式
const methods = [
  { value: true, label: "PE.RelativeTime" },
  { value: false, label: "PE.AbsoluteTime" }
];
// 计时单位
const timeunits = [
  { value: "1", label: "PE.Second" },
  { value: "2", label: "PE.Minutes" },
  { value: "3", label: "PE.Hour" }
];
// 显示风格
const timestyles = [
  { value: 0, label: "PE.TimeFormat1" },
  { value: 1, label: "PE.TimeFormat2" }
];
export default {
  name: "AttrTimewait",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      predefineColors,
      animations,
      familys,
      // fontSize,
      methods,
      timeunits,
      timeunitType: "1",
      relativeTime: 0, // 相对时间
      absoluteTime: new Date(), // 绝对时间
      timestyles,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    }
  },
  mounted() {
    console.log(this.media);
  },
  methods: {
    relativeTimeChange(val) {
      switch (this.timeunitType) {
        case "1":
          this.media.ext_val_relativeTime = val;
          break;
        case "2":
          this.media.ext_val_relativeTime = val * 60;
          break;
        case "3":
          this.media.ext_val_relativeTime = val * 60 * 60;
          break;
        default:
          break;
      }
    },
    setFontSize(val) {
      if (typeof (val) === "number") {
        this.media.ext_val_textSize = val;
      }
    },
    // absoluteTimeChange(val) {
    //   this.media.ext_val_absoluteTime = Math.ceil(val.getTime() / 1000);
    // }
  },
  watch: {
    'media.ext_val_relativeTime': {
      handler(nVal) {
        console.log(nVal);
        switch (this.timeunitType) {
          case "1": this.relativeTime = nVal; break;
          case "2": this.relativeTime = Math.floor(nVal / 60); break;
          case "3": this.relativeTime = Math.floor(nVal / 60 / 60); break;
          default: break;
        }
      },
      immediate: true
    },
    // 'media.ext_val_absoluteTime': {
    //   handler(nVal) {
    //     this.absoluteTime = new Date(nVal * 1000);
    //   },
    //   immediate: true
    // }
  },
  components: {
    SetFontSize
  }
}
</script>

<style lang="scss" scoped>
.attr-timewait {
  padding-right: 4px;
  .timewait-item {
    min-height: 36px;
    margin: 8px 0px;
    .timewait-attr {
      width: 100px;
      // font-family: 'Times New Roman';
      // font-weight: normal;
      // font-stretch: normal;
      // color: #617883;
    }
    .timewait-attr-child {
      width: 130px;
      height: 64px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .el-checkbox {
    margin-right: 26px;
  }
}
</style>